import useQuery from "app/common/custom-hooks/useQuery";
import { trackInvite } from "app/redux/auth/authHandler";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";


const AcceptInvite = _ => {

    const sgn = useQuery("sgn");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(_ => {
        if (sgn){
            const invite = Object.fromEntries(new URLSearchParams(atob(sgn)));
            console.log({invite})
            dispatch(trackInvite(invite));
        }
        navigate("/register");
    }, [dispatch, navigate, sgn])

    return null;
}

export default AcceptInvite;